/* unplugin-vue-components disabled */import { render } from "./Loading.vue?vue&type=template&id=22f09c54"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"

import "./Loading.vue?vue&type=style&index=0&id=22f09c54&lang=scss"
script.render = render

export default script